import * as React from "react"

import type { NamedRoutes } from "shared/utils/routes"

import Page from "./Page"

export const namedRoutes: NamedRoutes = {
  all: {
    pathTemplate: "preview",
    element: <Page />,
  },
  product: {
    pathTemplate: "preview/products/:productId",
    element: <Page />,
  },
  category: {
    pathTemplate: "preview/products/category/:categoryId",
    element: <Page />,
  },
  deal: {
    pathTemplate: "preview/deals/:dealId",
    element: <Page />,
  },
}
